import { jsx } from 'react/jsx-runtime';
import React__default, { useMemo } from 'react';
import { Image } from '../Image/Image.esm.js';
import { cn } from '../../utils/cn.esm.js';

const DEFAULT_COMMON_IMAGE_CONFIG = {
    width: 600,
    height: 400,
    alt: "image",
};
const isImageConfig = (val) => typeof val === "object" && val !== null && "src" in val;
const useCommonImage = (image, baseClassName) => {
    return useMemo(() => {
        var _a;
        if (!image)
            return null;
        // React element passed directly
        if (React__default.isValidElement(image)) {
            // Only append our class if the element doesn't already have one
            return React__default.cloneElement(image, {
                className: cn(((_a = image === null || image === void 0 ? void 0 : image.props) === null || _a === void 0 ? void 0 : _a.className) || "", baseClassName),
            });
        }
        // String => treat as src
        if (typeof image === "string") {
            return (jsx(Image, { src: image, alt: DEFAULT_COMMON_IMAGE_CONFIG.alt, width: DEFAULT_COMMON_IMAGE_CONFIG.width, height: DEFAULT_COMMON_IMAGE_CONFIG.height, className: baseClassName }));
        }
        // Config object
        if (isImageConfig(image)) {
            const { src, alt = DEFAULT_COMMON_IMAGE_CONFIG.alt, width = DEFAULT_COMMON_IMAGE_CONFIG.width, height = DEFAULT_COMMON_IMAGE_CONFIG.height, loading, className, } = image;
            return (jsx(Image, { src: src, alt: alt, width: width, height: height, loading: loading, className: cn(baseClassName, className) }));
        }
        return null;
    }, [image, baseClassName]);
};

export { DEFAULT_COMMON_IMAGE_CONFIG, useCommonImage };
